export default "__VITE_ASSET__BW1cOW0g__"